import {Injectable} from '@angular/core';
import {BehaviorSubject} from '../../../../node_modules/rxjs';
import {ColdStore} from '../../pages/user-management/cold-store/cold-store.model';

@Injectable()
export class DataService {

    private messageSource = new BehaviorSubject([]);
    currentValue = this.messageSource.asObservable();

    private countSource = new BehaviorSubject({});
    currentCount = this.countSource.asObservable();

    constructor() {
    }

    changeValue(message: ColdStore[]) {
        this.messageSource.next(message);
    }

    changeCount(count: object) {
        this.countSource.next(count);
    }

}
